// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1Ffgw","also-read-bottom":"_3IPba","metype":"nVj0J","fallback-text":"_UIfC"};